module.exports = __webpack_public_path__ + "img/projects.6c5fccba.svg";